// extracted by mini-css-extract-plugin
export default {"textarea_input":"textarea_textarea_input__r6C3G","glow":"textarea_glow__XY7KY"};